import * as firebase from "firebase";
import "firebase/database";

let config = {
    apiKey: "AIzaSyAl6OT62LMlRHjnqJTJ6XuPYWocbEBb3KI",
    authDomain: "luinny-corporan-793b3.firebaseapp.com",
    databaseURL: "https://luinny-corporan-793b3-default-rtdb.firebaseio.com",
    projectId: "luinny-corporan-793b3",
    storageBucket: "luinny-corporan-793b3.firebasestorage.app",
    messagingSenderId: "1042689633330",
    appId: "1:1042689633330:web:193c71d967b405355ba02b",
    measurementId: "G-P9MWGV6QGR"
};

firebase.initializeApp(config);

export default firebase.database();